import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchBeginLoadCart, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getIsCanadaWebsite } from "@midland-industries/Components/WebsiteSelector";

type LoadCurrentCartProps = Parameters<typeof DispatchBeginLoadCart>[0];

function SetAdditionalExpendsWarehouse(props: LoadCurrentCartProps) {
    const state = props.getState();
    if (getIsCanadaWebsite(state)) {
        props.apiParameter.additionalExpands = [];
        props.apiParameter.additionalExpands.push("warehouses");
    }
}

addToChainAfter(chain, PopulateApiParameter, SetAdditionalExpendsWarehouse);
